<template>
	<form class="relative" ref="form" :action="action"  @submit.prevent="onSubmit">
		<div class="mb-4">
			<input name="name" class="input text-primary placeholder-secondary-200" v-model="form.name" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('name')}" type="text" :placeholder="t('name')">
			<span v-show="errors.has('name')" class="text-red-500 text-sm mt-2">{{ errors.first('name') }}</span>
		</div>
		<div class="mb-4">
			<input name="email" class="input text-primary placeholder-secondary-200" v-model="form.email" v-validate="{ required: true}" :class="{'border-red-500': errors.has('email')}" type="email" :placeholder="t('email')">
			<span v-show="errors.has('email')" class="text-red-500 text-sm mt-2">{{ errors.first('email') }}</span>
		</div>
		<div class="mb-4">
			<input type="text" v-model="form.phone" name="phone" :placeholder="t('phone')" class="input text-primary placeholder-secondary-200 custom-telnumber" v-validate="{ required: true ,digits:10 }" @onBlur="checkUniq($event,checkPhone,'phone')">
			<span v-show="errors.has('phone')" class="text-red-500 text-sm mt-2">{{ errors.first('phone') }}</span>
			<span ref="phone" class="text-red-500 text-sm mt-2 hidden"></span>
		</div>
		<div class="mb-4">
			<input name="password" class="input text-primary placeholder-secondary-200" v-model="form.password" v-validate="{ required: true , min:6 ,max:255 }" :class="{'border-red-500': errors.has('password') }" :type="passwordFieldType" :placeholder="t('password')" ref="password">
			<span v-show="errors.has('password')" class="text-red-500 text-sm mt-2">{{ errors.first('password') }}</span>
		</div>
		<div class="mb-4">
			<input name="password_confirmation" class="input text-primary placeholder-secondary-200" v-model="form.password_confirmation" v-validate="'required|min:6|max:255|confirmed:password'" :class="{'border-red-500': errors.has('password_confirmation') }" :type="passwordFieldType" :placeholder=" t('password_confirmation') ">
			<span v-show="errors.has('password_confirmation')" class="text-red-500 text-sm mt-2">{{ errors.first('password_confirmation') }}</span>
		</div>
		<div class="mb-4">
			<input name="country" class="input text-primary placeholder-secondary-200" v-model="form.country" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('country')}" type="text" :placeholder="t('country')">
			<span v-show="errors.has('country')" class="text-red-500 text-sm mt-2">{{ errors.first('country') }}</span>
		</div>
		<div class="mb-4">
			<input name="city" class="input text-primary placeholder-secondary-200" v-model="form.city" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('city')}" type="text" :placeholder="t('city')">
			<span v-show="errors.has('city')" class="text-red-500 text-sm mt-2">{{ errors.first('city') }}</span>
		</div>
		<div class="mb-4">
			<input name="area" class="input text-primary placeholder-secondary-200" v-model="form.area" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('area')}" type="text" :placeholder="t('area')">
			<span v-show="errors.has('area')" class="text-red-500 text-sm mt-2">{{ errors.first('area') }}</span>
		</div>
		<div class="mb-4">
			<button type="submit" class="button bg-secondary-200 hover:bg-primary text-white text-xs md:text-base" :disabled='isDisabled'>{{t('register_new')}}</button>
		</div>
		<div  v-if="success" class="loading-register-state absolute inset-0 z-10 flex justify-center content-center self-center items-center flex-wrap " style="background-color: #ffffff6e">
			<img src="/front/img/illustrations/home_loader.svg" class="m-auto h-10 w-10 mb-5">
		</div>
	</form>
</template>
<script>
import axios from 'axios';
import arabic from 'vee-validate/dist/locale/ar';
import { Validator , mapFields} from 'vee-validate';
import trans from './translation/user.json';
export default {
	name: 'Register',
	props: {
		action: {
			type: String,
			required: true
		},
		sitelocale:{
			type: String,
			required: true
		},
		checkPhone:{
			type: String,
			required: true
		},
	},
	data: () => ({
		submitting: false,
		success: false,
		form : {
			name: '',
			password:'',
			password_confirmation:'',
			email : '',
			phone : '',
			country: '',
			city: '',
			area: ''		},
		passwordFieldType: 'password',
		phone: {
			number: '',
			isValid: false,
		},
		isDisabled:false
	}),
	mounted() {
		this.$translate.setLang(this.sitelocale);
		},
		locales: trans,
		created() {
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
				custom:trans.ar.custom
			});
			this.$validator.localize('en', {
				custom:trans.en.custom
			});

			Validator.localize(this.sitelocale);
			console.log(this.action);
		},
		methods: {
			checkUniq(data,route,fieldname){
				let input = '' ;
				if(fieldname == 'phone') {
					data = this.form.phone;
				} else {
					input = data.target;
					data =  data.target.value;
				}
				let message = this.$refs[fieldname];
				if(!this.errors.has(fieldname)){
					axios.post(route, {'key' : fieldname,'value' : data })
					.then( response => {
						if (input != '') {
							input.classList.remove('is-danger');
						}
						this.$refs[fieldname].classList.add('hidden');
						message.innerHTML = "";
					})
					.catch(error => {
						if (input != '') {
							input.classList.add('is-danger');
						}
						message.innerHTML = error.response.data.message;
						this.$refs[fieldname].classList.remove('hidden');
					});
				}
			},
			onSubmit(){
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.isDisabled=true
						this.submitting = true;
						const action = this.action;
						axios.post(action, this.form)
						.then(response => {
	                        this.$toasted.success(response.data.message);
							this.success = true;
							this.clearInputs();
							setTimeout(()=>{
								window.location.href = `/`;
							}, 2000);
	                    })
						.catch(error => {
							this.isDisabled=false
							console.log(error);
							let toaster = this.$toasted;
							$.each(error.response.data.errors, function(key, value) {
								toaster.error(value.message);
							});
							this.success = false;

						})
						.then(()=>{
							this.submitting = false;
							setTimeout(()=>{
								this.success = false;
							}, 3500);
						});

					}

				});

			},
			clearInputs(){
				let inputs = document.querySelectorAll(".form-block .form-element");

				$.each(inputs, function(key, value) {
					console.log(value.tagName);
					if(value.tagName  == 'INPUT' || value.tagName  == 'TEXTAREA'){
						value.value ="";
					}else{
						value.innerHTML="";
					}
				});
			},
		}
	};
</script>
<style type="text/css">
.hidden{
	display: none;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/Register.vue